import React from "react";
import "../css/forgotPassword.css"
import { NavLink } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
function ForgotPassword() {

    const [email, setEmail] = useState("");
    const [busy,setBusy] = useState(false);
    const [message, setMessage] = useState("");


    const navigate = useNavigate();
    
    const handleChange = async()=>{
        try {
            setBusy(true)
           const response = await axios.post(`https://petme.onrender.com/user/forgot-password`, {email })

           const data = await response.data;
           
           if (data.success) {
            setMessage(data.message);
            setTimeout(() => {
              navigate("/login");
            }, 3000);
          }else{
            setMessage(data.error)
          }
        } catch (error) {
            setMessage(error.response.data.error);
            console.log(error)
            
        }
    }


    if(busy){

        <h1>Please wait........</h1>
    }



    return (

        <div>
            <div className="forgotPassword-bg_img"></div>
            <div className="forgotPassword-div">
                <div className="forgotPassword-content">
                    <h2 className="forgotPassword-heading">Forgot Password</h2>
                    <p className="forgotPassword-msg">Enter your email for the verification process,<br />We will send 4 digits otp to your mail.</p>
                    <div className="forgotPassword-emailDiv">
                        <p className="forgotPassword-email">Email</p>
                        <input id="email" type="email" name="email" className="box forgotPassword-inputBox" placeholder="email address"  onChange={(e) =>{setEmail(e.target.value)}}/>
                        {message && <p>{message}</p>}
                    </div>
                    <NavLink className="forgotPassword-continueNavlink" ><button type="button" className="forgotPassword-continueBtn " onClick={handleChange}>CONTINUE</button></NavLink>
                </div>
            </div>
        </div>

    );
}


export default ForgotPassword